import { render, staticRenderFns } from "./U3Queue.vue?vue&type=template&id=92e09d3e&"
import script from "./U3Queue.js?vue&type=script&lang=js&"
export * from "./U3Queue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/frameto/WebSites/U3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('92e09d3e', component.options)
    } else {
      api.reload('92e09d3e', component.options)
    }
    module.hot.accept("./U3Queue.vue?vue&type=template&id=92e09d3e&", function () {
      api.rerender('92e09d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/U3Queue.vue"
export default component.exports